import React from 'react';

export const SITE_URL = 'https://createcollect.com';

export const PLAN_PRICING = [
  { name: 'Free', price: 0 },
  { name: 'Standard', price: 5 },
  { name: 'Pro', price: 8 },
];

export const faqJsonLd = (faqs) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((f) => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a },
  })),
});

// React 19 hoists title/meta/link rendered anywhere in the tree into <head>.
// JSON-LD script tags are valid anywhere in the document per schema.org/Google.
export const Seo = ({ title, description, path, noindex, jsonLd }) => (
  <>
    {title ? <title>{title}</title> : null}
    {title ? <meta property="og:title" content={title} /> : null}
    {description ? <meta name="description" content={description} /> : null}
    {description ? <meta property="og:description" content={description} /> : null}
    {path !== undefined ? <meta property="og:url" content={`${SITE_URL}${path}`} /> : null}
    {path !== undefined ? <link rel="canonical" href={`${SITE_URL}${path}`} /> : null}
    {noindex ? <meta name="robots" content="noindex, follow" /> : null}
    {jsonLd
      ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]).map((obj, i) => (
          <script key={i} type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(obj) }} />
        ))
      : null}
  </>
);
